export default __webpack_public_path__ + "static/media/HANG.08dfcf9c.png";